import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import aboutHero from "../../images/aboutusland.jpeg";


const styles = {
    parenBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      px:"5px",
      paddingTop:"50px",
      gap:10,
    },
    leftBox: {
      display: "flex",
      alignItems: "start",
      justifyContent: "center",
      flexDirection: "column",
      gap:3,
    },
    rightBox: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    heroTitle: {
      fontFamily: "poppins",
      fontWeight: "bold",
      lineHeight:1.5,
      opacity: 0.7,
    },
    heroSubtitle: {
      fontFamily: "poppins",
      fontWeight:600,
      opacity:0.7
    },
    button: {
      px: "10px",
      py:"5px",
      fontFamily: "poppins",
      fontSize: "14px",
      textTransform: "none",
      backgroundColor: "#141414FF",
      color: "#ffffff",
    },
  };


const AboutUsHero = () => {
  return (
   <Container maxedWidth="xl">  

    <Box sx={{ ...styles.parenBox }}>
        <Box sx={{ ...styles.leftBox }}>
          <Typography variant="h4" textAlign={"start"} sx={{ ...styles.heroTitle }}>
          More Than a Practice <br /> It's a Way of Life
          </Typography>
         
         
        </Box>

        <Box sx={{ ...styles.rightBox }}>
          <Box component="img" src={aboutHero} sx={{width:"650px",heigh:"650px",borderRadius:"25px"}}/>
        </Box>
      </Box>
    

   </Container>
  )
}

export default AboutUsHero